import { Link } from "react-router-dom";
import type { Expense } from "@/models/types";
import CategoryBadge from "@/components/feature/CategoryBadge";
import { formatCurrency } from "@/utils/currency";
import { formatShortDate } from "@/utils/date";
import { paymentIcon } from "@/utils/format";

interface ExpenseCardProps {
  expense: Expense;
  currencyCode?: string;
}

export default function ExpenseCard({
  expense,
  currencyCode = "MXN",
}: ExpenseCardProps) {
  return (
    <Link
      to={`/gastos/${expense.id}`}
      className="block bg-background-50 border border-background-200 rounded-lg p-4 hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="font-medium text-foreground-950 truncate">
            {expense.description}
          </p>
          <div className="mt-1.5 flex items-center gap-2 flex-wrap">
            <CategoryBadge categoryId={expense.categoryId} />
            <span className="text-xs text-foreground-500">
              {formatShortDate(expense.date)}
            </span>
          </div>
        </div>
        <p className="font-heading font-bold text-foreground-950 whitespace-nowrap">
          {formatCurrency(expense.amount, currencyCode)}
        </p>
      </div>
      <div className="mt-3 flex items-center gap-3 text-xs text-foreground-500">
        <span className="inline-flex items-center gap-1">
          <i className={`${paymentIcon(expense.paymentMethod)}`} />
        </span>
        {expense.receipt && (
          <span className="inline-flex items-center gap-1 text-primary-600">
            <i className="ri-receipt-line" />
            Recibo
          </span>
        )}
      </div>
    </Link>
  );
}